import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

export const useLocaleText = createLocaleTextHook({
  dictionary: {
    'skeleton_carousel.loading_indicator_carousel': {
      'en-GB': 'Loading indicator carousel title',
      'nl-NL': 'Bezig met laden van carrouselindicator',
    },
    'skeleton_carousel.loading_indicator_carousel_product_tile': {
      'en-GB': 'Loading indicator carousel product tile',
      'nl-NL': 'Bezig met laden van indicator carrouselproducttitel',
    },
  },
})
